import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
import { faFileLines } from '@fortawesome/free-regular-svg-icons/faFileLines';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

// `link` may be a function of the current language.
const data = [
  {
    link: 'mailto:sarabuczna@gmail.com',
    label: 'Email',
    icon: faEnvelope,
  },
  {
    link: (lang) => `/resume/${lang}`,
    label: 'Resume',
    icon: faFileLines,
  },
];

export default data;
